import getSorter from './getSorters'

export default function sortOrgs(orgA, orgB) {
  const a = orgA.name.toLowerCase()
  const b = orgB.name.toLowerCase()

  return getSorter('org', a, b)
}
